import React from 'react';

const CertificationsSection = () => {
  const certifications = [
    { name: 'Quality Management', desc: 'International quality standards', image: 'https://images.pexels.com/photos/590016/pexels-photo-590016.jpeg' },
    { name: 'Environmental', desc: 'Environmental management', image: 'https://images.pexels.com/photos/3735218/pexels-photo-3735218.jpeg' },
    { name: 'Information Security', desc: 'Data protection standards', image: 'https://images.pexels.com/photos/459411/pexels-photo-459411.jpeg' },
    { name: 'Health & Safety', desc: 'Occupational safety', image: 'https://images.pexels.com/photos/7788241/pexels-photo-7788241.jpeg' },
  ];

  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
            Certified
          </p>
          <h2 className="text-3xl lg:text-4xl font-light text-[#0a1628]">
            Our Commitment to <span className="font-semibold">Excellence</span>
          </h2>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {certifications.map((cert, i) => (
            <div
              key={i}
              className="group bg-[#f8fafc] hover:bg-white hover:shadow-lg transition-all duration-500 ease-out text-center border border-transparent hover:border-gray-200 overflow-hidden"
            >
              <div className="h-36 overflow-hidden">
                <img
                  src={cert.image}
                  alt={cert.name}
                  className="w-full h-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
                />
              </div>
              <div className="p-8">
                <h3 className="text-lg font-semibold text-[#0a1628] mb-2 transition-colors duration-300">
                  {cert.name}
                </h3>
                <p className="text-sm text-gray-500 transition-colors duration-300">
                  {cert.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Text */}
        <div className="mt-12 text-center">
          <p className="text-gray-500">
            Trusted by Fortune 500 companies and leading enterprises across the GCC region
          </p>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
